export var SeriesType;
(function (SeriesType) {
    SeriesType["Line"] = "line";
    SeriesType["Scatter"] = "scatter";
})(SeriesType || (SeriesType = {}));
